/**
 * @file maklik.js
 * @name Maklik JS
 * @desc core Maklik JS Library
 * @copy Copyright &copy;2012-2015 Maklik. All rights reserved.
 * @license http://bit.ly/1foqz9x
 */
var Maklik = (function() {

	//
	var $, maklik={},
		ea = [],
		slice = ea.slice,
		getComputedStyle = document.defaultView.getComputedStyle,
		defaultDisplay = {},
		cssNopx = { //what css attributes to *not* append "px" to
			'column-count': 1, 'columns': 1, 'font-weight': 1,
			'line-height': 1,'opacity': 1, 'z-index': 1, 'zoom': 1
		},
		//
		classCache = {},
		// events
		handlers = {}, //event handlers
		_handleid = 1, //event handler ids
		specialEvents={},
		// window history
		history = window.history,
		extend = null,
		// html fragments
		fragmentRE = /^\s*<(\w+|!)[^>]*>/,
		createElement = function(tag) { return document.createElement(tag) },
		table = createElement('table'),
		tableRow = createElement('tr'),
		containers = {
			'tr': createElement('tbody'),
			'tbody': table, 'thead': table, 'tfoot': table,
			'td': tableRow, 'th': tableRow,
			'*': createElement('div')
		},
		_urldecode_str = decodeURIComponent,
		_urlencode_str = encodeURIComponent,
		ajax, jaax,
	undefined;
	specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents'
	//
	// helper functions
	function noop(){}
	function is(value,type) { return value instanceof type }
	function is_maklik(v) { return is(v,maklik.C) || (v && v.__proto__ && v.__proto__==$.fn) } // second half forIE10
	function is_function(value) { return is(value,Function) }
	function is_string(value) { return typeof value=='string'; }
	function is_number(value) { return typeof value=='number'; }
	function is_object(value) { return is(value,Object); }
	function is_array(value) { return is(value,Array); }
	function is_jsobject(value) {
		var key, ctor
		if(!is_object) return false
		ctor = (is_function(value.constructor) && value.constructor.prototype)
		if(!ctor || !hasOwnProperty.call(ctor, 'isPrototypeOf')) return false
		for(key in value);
			return key === undefined || hasOwnProperty.call(value, key)
	}
	//
	// helpers used in collection functions ($.fn)
	function farg(c, arg, index, d) { return is_function(arg) ? arg.call(c, index, d) : arg }
	function extract_nodes(collection, name, selector) {
		var t=$(),v
		collection.map(function(){
			v=this[name]
			if(v && t.indexOf(v)<0) t.push(v)
		})
		return filtered(t,selector)
	}
	function re_class(name) {
		return name in classCache ?
		classCache[name] : (classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)'))
	}
	function str_dash2camel(str) {
		return str.replace(/-+(.)?/g, function(match, chr){ return chr ? chr.toUpperCase() : '' })
	}
	function str_camel2dash(str) {
		return str.replace(/::/g, '/')
			.replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
			.replace(/([a-z\d])([A-Z])/g, '$1_$2')
			.replace(/_/g, '-')
			.toLowerCase()
	}
	//
	// helpers for events
	function handleid(element) { return element.__hid || (element.__hid = _handleid++) }
	function e_parse(event) {
		var parts = ('' + event).split('.')
		return {e: parts[0], ns: parts.slice(1).sort().join(' ')}
	}
	function e_loop(events, fn, iterator) {
		if (is_object(events)) $.each(events, iterator)
		else events.split(/\s/).forEach(function(type){ iterator(type, fn) })
	}
	function e_gethandles(element, event, fn, selector) {
		event = e_parse(event)
		if(event.ns) var matcher = matcherFor(event.ns)
		return (handlers[handleid(element)] || []).filter(function(handler) {
			return handler
				&& (!event.e  || handler.e == event.e)
				&& (!event.ns || matcher.test(handler.ns))
				&& (!fn       || handleid(handler.fn) === handleid(fn))
				&& (!selector || handler.sel == selector)
		})
	}
	//
	// event add/remove functions
	function event_add(element, events, fn, selector, getDelegate, capture){
		// don't process js objects or items that can't have event listeners
		if(!element.addEventListener) return
		capture = !!capture
		var id = handleid(element), set = (handlers[id] || (handlers[id] = []))
		e_loop(events, fn, function(event, fn){
			var delegate = getDelegate && getDelegate(fn, event),
			callback = delegate || fn
			var proxyfn = function (event) {
				var result = callback.apply(element, [event].concat(event.data))
				if (result === false) event.preventDefault()
				return result
			}
			var tmp=e_parse(event), handler = {
				e: tmp.e, ns: tmp.ns,
				fn: fn, proxy: proxyfn, sel: selector, del: delegate, i: set.length
			}
			set.push(handler)
			element.addEventListener(handler.e, proxyfn, capture)
		})
	}
	function event_remove(element, events, fn, selector){
		var id = handleid(element)
		e_loop(events || '', fn, function(event, fn){
			e_gethandles(element, event, fn, selector).forEach(function(handler){
				delete handlers[id][handler.i]
				element.removeEventListener(handler.e, handler.proxy, false)
			})
		})
	}
	//
	// urlencode helpers / recursion
	function _urlencode_dom(obj, prefix) { // dom objects and maklik collections
		var v, s = []
		$(obj).find('input,textarea,select').each(function(){
			// access attributes
			var t=$(this), type=t.attr('type'), name=t.attr('name'), val=t.val(),
				p = !name ? -1 : name.indexOf('[') // find first open array tag (assume rest of str is arr values)
			// skip buttons and non-checked radio/checkboxes
			if(type=='submit' || type=='button'
				|| ((type=='radio' || type=='checkbox') && !t.prop('checked'))
			) return
			// add item to array (put only if it has a value
			if((v = (prefix
				? prefix+'['+ ( p<0 ? name+']' : name.substr(0,p)+']'+name.substr(p) )
				: name )
				+'='+_urlencode_str(val))!='') s.push(v)
		})
		return s.length>0 ? s.join('&') : ''
	}
	function _urlencode_object(values, prefix) { // javascript objects and arrays
		var i,p,v,x,s = []
		for(i in values) {
			v=values[i], p = prefix ? prefix+'['+i+']' : i
			if((x=is_maklik(v)
					? _urlencode_dom(v,p)
					: (is_object(v)
						? _urlencode_object(v,p)
						: _urlencode_str(p)+'='+_urlencode_str(v)
					)
				)!=''
			) s.push(x)
		}
		//return s
		return s.length>0 ? s.join('&') : ''
	}
	//
	// urldecode helpers
	function _urldecode_checkarr(x) {
		// check for and/or convert x from obj to arr if indexes make sense
		var i, n=0, isobj = false
		if(!is_object(x)) return x
		for(i in x) {
			// see if index is object or array
			if(((n++)+'')!=i) isobj = true
			// recurse for sub-objects
			x[i] = (is_object(x[i]) ? _urldecode_checkarr(x[i]) : x[i])
		}
		// if it's an array, do the conversion
		if(!isobj) {
			n = []
			for(i in x) n.push(x[i])
			x = n
		}
		return x
	}
	function _urldecode_process(str) {
		// do the actual urldecoding
		var args = (str[0] && str[0]=='?' ? str.substr(1) : str).split('&'),
			res={}, key, val, tmp, p, q, k, sk
		// if only one argument, as string, and '=' is not in it, just decode the string
		if(args.length==1 && is_string(str) && str.indexOf('=')<0) return _urldecode_str(str)
		// process each argument to build an object
		args.forEach(function(v){
			p = v.indexOf('=')
			if(p<0) res[_urldecode_str(v)] = undefined
			else {
				key = _urldecode_str(v.substr(0,p))
				val = _urldecode_str(v.substr(p+1))
				// look for indexes
				if((p=key.indexOf('['))>=0 && (q=key.indexOf(']'))>=0 && q>p) {
					// get key name and sub key
					k = key.substr(0,p).trim()
					if(!is_object(res[k])) res[k] = {}
					// prep for loop
					tmp = res[k]
					sk = ''
					do {
						// get next sub key
						if(sk!=='') tmp = tmp[sk]        // skips on first do loop
						sk = key.substring(p+1,q).trim() // get next sub key
						// use numerical index if subkey is blank (allows for "&key[]=...&key[]=..." arrays)
						sk = sk=='' ? Object.keys(tmp).length : sk
						if(!tmp[sk]) tmp[sk] = {}
						// see if there is another key
						p = key.indexOf('[',p+1)
						q = key.indexOf(']',p+1)
					} while(p>=0 && q>=0 && q<key.length)
					// assign value
					tmp[sk] = val
				} else {
					// no indexes; just assign value
					res[key] = val
				}
			}
		})
		return _urldecode_checkarr(res)
	}
	//
	// for querying/filtering nodes and collections
	function filtered(nodes, selector) { // filter a collection based on a selector
		return selector === undefined ? $(nodes) : $(nodes).filter(selector)
	}

	/*************************************************************************************************/
	//
	// create a Maklik JS Collection
	//

	//
	// query the dom
	//
	function _query_selector(e,s) {
		return (e.nodeType!==1 && e.nodeType!==9) ? ea : slice.call(e.querySelectorAll(s));
	}

	//
	// create nodes from html string
	//
	function _collection_from_fragment(html,name) {
		//if name is not passed, get the first name from the regex
		if(name === undefined) name = fragmentRE.test(html) && RegExp.$1
		//get the container element and add our string to it
		var container = containers[!(name in containers) ? '*' : name]
		container.innerHTML = '' + html
		//return all of the added elements as an array
		return $.each(slice.call(container.childNodes), function(){
			container.removeChild(this)
		})
	}
	//
	// determine if the given element matches the selector (returns true/false)
	//
	function _element_matches_selector(element, selector) {
		// make sure we have an element
		if(!element || element.nodeType !== 1) return false
		// use the browser-optimized match selectors
		// note: browsers without match selectors (eg, old IE and Opera Mini) will need maklik-patch.js to work
		var sel = element.webkitMatchesSelector || element.mozMatchesSelector  // webkit || mozilla
					|| element.oMatchesSelector || element.msMatchesSelector   // opera || ms
					|| element.matchesSelector                                 // others
		// forIE10 - ie 10 cannot handle functions
		if(is_function(selector) && (navigator.userAgent.indexOf("MSIE") != -1)) {
			var items = []
			$(element).each(function(i,x){ if(selector.call(this,x)) items.push(x) })
			return items
		} else {
			// what life would be like without IE ....
			return sel.call(element, selector)
		}
	}

	/*************************************************************************************************/
	//
	// create a Maklik JS Collection
	//
	maklik.C = function(dom, selector) {
		// empty collection if no dom passed
		dom = dom || []
		// swap out normal dom function with ours
		if(!dom.__proto__) {                  // forIE10 - stupid IE!
			for(x in $.fn) dom[x] = $.fn[x]   // forIE10 - add functions instead of replacing them
			dom.__proto__ = $.fn              // forIE10 - creates a __proto__ obj so is_maklik() can work on IE 10
		} else dom.__proto__ = $.fn  // what life would be like without IE... *sigh*
		// empty selector if it was not passed
		dom.selector = selector || ''
		// return the collection
		return dom
	}


	/**
	 * @func $()
	 * @desc The magic dollar sign
	 * @use =Maklik  selector,  !context
	 * @use =Maklik  html_string
	 * @use =Maklik  function
	 * @use =Maklik  Maklik
	 * @use =Maklik  DOMNode
	**/
	$ = function(s,c) { return maklik.$(s,c); }  // maklik.$ or dom.__proto__ fails in maklik.C
	maklik.$ = function(selector, context){
		// check for special cases
		if(!selector) return maklik.C()  // no arguments = return empty collection
		else if(is_function(selector))   // function = call when dom is ready
			return $(document).ready(selector)
		else if( is_maklik(selector) ) // collection = return the collection
			return selector
		else {
			var x
			// build collecton from array of nodes (ignoring undefined and null objects
			if(is_array(selector))
				x = selector.filter(function(item){ return item !== undefined && item !== null })
			// wrap DOM nodes; if a plain object is given, return a copy of it (so we don't interfere with user's code)
			else if(is_object(selector))
				//x = [is_jsobject(selector) ? extend({},selector) : selector], selector = null
				x = [selector], selector = null
			// html fragments
			else if(fragmentRE.test(selector))
				x = _collection_from_fragment(selector.trim(), RegExp.$1), selector = null
			// must be a css selector; but if there is a context, do the search from there
			else if(context !== undefined) return $(context).find(selector)
			// must be a css selector, but there is no context, so search entire document
			else x = _query_selector(document, selector)
			// create a new Maklik collection from the nodes found
			return maklik.C(x, selector)
		}
	}

	/*************************************************************************************************/
	//
	// functions for collections
	//
	$.fn = {
		//
		forEach: ea.forEach,
		reduce: ea.reduce,
		push: ea.push,
		indexOf: ea.indexOf,
		concat: ea.concat,
		//
		// add element(s) to the collection
		add: function(selector,context) {
			var t=this
				$(selector,context).each(function(i,e){ // get the list of objects to add, and...
					if(t.indexOf(e)<0) t.push(e)        // add them (if they are not already in the collection)
				})
			return t
		},
		//
		// add a css class
		addClass: function(name) {
			return this.each(function(index){
				var list=[], cls=this.className, nname = farg(this, name, index, cls), e=$(this);
				//add classes to list if they're not already there
				nname.split(/\s+/g).forEach(function(x){ if (!e.hasClass(x)) list.push(x) }, this)
				//add classes to name as string
				list.length && (this.className += (cls ? ' ' : '') + list.join(' '))
			})
		},
		//
		// get element (object) at specific index
		at: function(index) {
			return $(!is_number(index) || index>=this.length ? null : this[index>=0 ? index : index + this.length])
		},
		//
		// get or set an element attribute (eg, 'name', 'src', 'href')
		attr: function(name,value) {
			var result
			return (is_string(name) && value === undefined)
				? (this.length == 0 || this[0].nodeType !== 1 ? undefined
				: (name == 'value' && this[0].nodeName == 'INPUT')
					? this.val()
					: (!(result = this[0].getAttribute(name)) && name in this[0])
						? this[0][name]
						: result
			) :
			this.each(function(index) {
				if(this.nodeType !== 1) return
				if(is_object(name)) for (key in name) this.setAttribute(key, name[key])
				else this.setAttribute(name, farg(this, value, index, this.getAttribute(name)))
			})
		},
		//
		// return new collection that is the children of this collection
		children: function(selector) {
			var t=$(),c,v,i
			this.map(function(){
				// get all the children
				c = this['children']
				if(c) for(i=0; i<c.length; i++) {
					v=c[i]
					// add child to collection if it's not in there already
					if(v && t.indexOf(v)<0) t.push(v)
				}
			})
			// filter out selection based on selector
			return filtered(t,selector)
		},
		//
		// clone all the dom nodes in this collection
		clone: function(deep) {
			return $.clone(this, deep)
		},
		//
		// like parent(), but keep iterating up until we find a selector or hit hte body
		closest: function(selector) {
			var c=$(), p=$(this), t
			while((t=p.get(0).tagName)!='BODY' && t!='HTML') {
				t = p.filter(selector)
				if(t.size()>0) {
					c.add(t)
					break
				}
				p = p.parent()
			}
			return c
		},
		//
		// get or set a css property value
		css: function(property, value) {
			// get css value
			if(arguments.length<2 && is_string(property))
				return this[0] && (
					this[0].style[str_dash2camel(property)] || getComputedStyle(this[0], '').getPropertyValue(property)
				)
			// local vars
			var t=this, css = '', dashed, px,
				update = function(k,v){
					dashed = str_camel2dash(k)
					px = is_number(v) && !cssNopx[dashed] ? 'px' : ''
					if(is_string(v) && v=='')
						t.each(function(){ this.style.removeProperty(dashed) })
					else
						css += dashed + ':' + v + px + ';'
				}
			// update all css values
			if(is_string(property))
				update(property, value)
			else
				for(key in property) update(key, property[key])
			// apply new rule to every element
			return this.each(function(){ this.style.cssText += ';' + css })
		},
		//
		// loop through collection and do something
		each: function(callback) {
			this.forEach(function(elem, index){ callback.call(elem, index, elem) })
			return this
		},
		//
		// clear the innerHTML for everyone in our collection
		empty: function() {
			return this.each(function(){ this.innerHTML = '' })
		},
		//
		// filter a collection based on some selector
		filter: function(selector){
			return $([].filter.call(this, function(element){
				return _element_matches_selector(element, selector)
			}))
		},
		//
		// find elements in collection based on query selector
		find: function(selector) {
			return $(this.length == 1
				? _query_selector(this[0], selector)
				: this.map(function(){ return _query_selector(this, selector) })
			);
		},
		//
		// get the first object in our collection
		first: function() {
			var e = this[0]
			return e && !is_object(e) ? e : $(e)
		},
		//
		// get DOM element at given index
		get: function(index) {
			return index>=this.length ? null : this[index>=0 ? index : index + this.length]
		},
		//
		// check if element has class
		hasClass: function(name) {
			if (this.length < 1) return false
			else return re_class(name).test(this[0].className)
		},
		//
		// hide elements
		hide: function() {
			var t=this, display
			t.each(function(i,e){
				if((display=e.style.display)!='none' && display!='')
					e.setAttribute('_mjs-display',display)
			});
			return t.css('display', 'none')
		},
		//
		// get or set element html
		html: function(str) {
			return (str === undefined
				? (this.length>0 ? this[0].innerHTML : null) //return the innerhtml
				: this.each(function(index) { this.innerHTML = farg(this,str,index,this.innerHTML) })
			);
		},
		//
		// get index within our collection of the passed element
		index: function(element) {
			return element ? this.indexOf($(element)[0]) : this.indexOf(this[0])
		},
		//
		// get the last object in our collection
		last: function(){
			var e = this[this.length - 1]
			return e && !is_object(e) ? e : $(e)
		},
		//
		//
		map: function(fn) {
			return $.map(this, function(el, i){ return fn.call(el, i, el) })
		},
		//
		// get the element(s) next to the current one(s)
		next: function() {
			return extract_nodes(this,'nextElementSibling')
		},
		//
		// get the element's offset
		offset: function() {
			if(this.length==0) return null
			var obj = this[0].getBoundingClientRect()
			return {
				left: obj.left + window.pageXOffset,
				top: obj.top + window.pageYOffset,
				width: obj.width,
				height: obj.height
			}
		},
		//
		// remove an event lister (must have been added by 'on')
		off: function(event, selector, callback) {
			return (selector==undefined || is_function(selector))
				? this.each(function(){ event_remove(this, event, callback) }) //unbind
				: this.each(function(){ event_remove(this, event, callback, selector)}) //undelegate
		},
		//
		// add an event listener
		on: function(event, selector, callback) {
			if(selector==undefined || is_function(selector)) {
				// no selector; just add the event
				return this.each(function(){ event_add(this, event, selector) })
			} else {
				// have a selector; means we need to add event delegation!
				return this.each(function(){
					// add event to parent element, but....
					event_add(this, event, callback, selector, function(fn){
						// only run user function if target matches the selector
						return function(e){
							if(_element_matches_selector(e.target, selector))
								return fn.apply(e.target, arguments)
						}
					})
				})
			}
		},
		//
		// add an event listener that removes itself the first time it's called
		once: function(event, selector, callback) {
			return is_function(selector) || selector==undefined
				?  // no selector; just add the function
				this.each(function(i, element){
					event_add(this, event, selector, null, function(fn, type){
						return function(){
							// execute function, but remove the handler immediately
							var result = fn.apply(element, arguments)
							event_remove(element, type, fn)
							return result
						}
					})
				})
				:  // this means there is a selector; ie, this is a delegation function
				this.each(function(i, element){
					// add event to parent element, but....
					event_add(this, event, callback, selector, function(fn, type){
						// only run user function if target matches the selector
						return function(e){
							if(_element_matches_selector(e.target, selector)) {
								// and if it matches selector, don't forget to remove handler immediately
								var result = fn.apply(e.target, arguments)
								event_remove(element, type, fn, selector)
								return result
							}
						}
					})
				})
		},
		//
		// return list of parent elements as new collection
		parent: function(selector) {
			return extract_nodes(this,'parentNode',selector)
		},
		//
		// find the closest ancestor(s) who match the given selector
		parents: function(selector) {
			var p = $(this).parent(), r=$()
			// no selector = get current parents (same as parent() function)
			if(selector===undefined) return p
			// keep looping up until we find a match or run out of parents
			while(p.size()>0 && (r=p.filter(selector)).size()<=0) p = p.parent();
			return r
		},
		//
		// get the element(s) previous to the current one(s)
		prev: function() {
			return extract_nodes(this,'previousElementSibling')
		},
		//
		// get or set dom property
		prop: function(name, value) {
			return (value === undefined)
				? (this[0] ? this[0][name] : undefined)
				: this.each(function(index){
					this[name] = farg(this, value, index, this[name])
				})
		},
		//
		// do something when the document is loaded
		ready: function(callback) {
			if(/complete|loaded|interactive/.test(document.readyState)) callback($)
			else document.addEventListener('DOMContentLoaded', function(){ callback($) }, false)
			return this
		},
		//
		// remove element(s) from dom
		remove: function() {
			return this.each(function() {
				if(this.parentNode!=null) this.parentNode.removeChild(this)
			})
		},
		//
		// remove the given attribute
		removeAttr: function(name) {
			return this.each(function(){ if(this.nodeType===1) this.removeAttribute(name) })
		},
		//
		// remove a css class from the elements
		removeClass: function(name) {
			return this.each(function(index){
				//no args means clear all classes
				if(name===undefined) return this.className = ''
				//class name as string
				var cl = this.className
				//use regex
				farg(this, name, index, cl).split(/\s+/g).forEach(function(x){
					cl = cl.replace(re_class(x), ' ')
				})
				this.className = cl.trim()
			})
		},
		//
		// show a hidden element
		show: function() {
			var old, node, t, dispattr='_mjs-display'
			return this.each(function(){
				// grab some stuffs
				t=this, old=t.getAttribute(dispattr), node=t.nodeName
				// get rid of our display attr (if it's there)
				t.removeAttribute(dispattr)
				// reset the display value (or clear it out if there is no value to reset it too)
				t.style.display=='none' && (t.style.display = (!old ? '' : old))
				// if the element is still hidden...
				if(getComputedStyle(t, '').getPropertyValue('display') == 'none') {
					// ... there is no value to reset it too ...
					if(!old) {
						// try to figure out what the display value should probably be
						if(!defaultDisplay[node]) {
							// make a throw-away element of the same name and get it's display value
							var element = createElement(node), display;
							document.body.appendChild(element)
							display = getComputedStyle(element, '').getPropertyValue("display")
							element.parentNode.removeChild(element)
							// if it is *still* not showing up, just default to 'block' value
							display == "none" && (display = "block")
							// keep a record of this node name so we're not continually creating throw-away elements
							defaultDisplay[node] = display
						}
						// use the guessed value for this node name
						t.style.display = defaultDisplay[node];
					} else t.style.display = old
				}
			})
		},
		//
		// return all of the sibling elements as a new collection
		siblings: function(selector) {
			var c=$(), t=$(this)
			t.parent().children(selector).each(function(i,e){
				if(c.indexOf(e)<0 && t.indexOf(e)<0) c.push(e)
			})
			return c
		},
		//
		// get number of elements in array
		size: function() {
			return this.length
		},
		//
		// return a subsection of this collection as a new collection
		slice: function() {
			return $(slice.apply(this, arguments))
		},
		//
		// get or set text value
		text: function(text) {
			return text === undefined
				? (this.length>0 ? this[0].textContent : null)
				: this.each(function(){ this.textContent = text })
		},
		//
		// toggle between showing and hiding an element
		toggle: function(setting){
			return (setting === undefined ? this.css("display") == "none" : setting) ? this.show() : this.hide()
		},
		//
		// toggl (add/remove) a css class
		toggleClass: function(name, when) {
			return this.each(function(index){
				var nname = farg(this, name, index, this.className), e=$(this)
				;(when===undefined ? !e.hasClass(nname) : when)
				? e.addClass(nname)
				: e.removeClass(nname)
			})
		},
		//
		// trigger an event to happen
		trigger: function(event, t) {
			//if event is a string, create an actual document event of that type
			if(is_string(event)) {
				var type = event;
				// notabene :: document.createEvent is *becoming* deprecated; once IE and safari get better support for
				// custom events, update this. cf:  https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent
				event = document.createEvent(specialEvents[type] || 'Events')
				event.initEvent(type, true, true)
			}
			//assign event data (which is all the arguments except the first, which is the event title)
			event.data = [].slice.call(arguments,1)
			if(t!==undefined) event.data = [t].concat(event.data)
			//trigger event
			return this.each(function(){
				// only trigger objects that can have event listeners attached to them
				// (eg, it is confusing, illogical, and unnecessary to attach or trigger
				//  a "click" handler on an non-dom object that cannot be clicked)
				if('dispatchEvent' in this) this.dispatchEvent(event)
			})
		},
		//
		// get value of element
		val: function(value) {
			return (value === undefined)
				? (this.length > 0 ? this[0].value : undefined)
				: this.each(function(index){
					this.value = farg(this, value, index, this.value)
				})
		}
	}

	//
	// width and height functions
	;['width', 'height'].forEach(function(dimension){
		var offset, Dimension = dimension[0].toUpperCase()+dimension.substr(1)
		$.fn[dimension] = function(value) {
			if(value === undefined) return this[0] == window
				? window['inner'+Dimension]
				: this[0] == document
					? document.documentElement['offset' + Dimension]
					: (offset=this.offset()) && offset[dimension]
			else return this.each(function(index){
				var e = $(this)
				e.css(dimension, farg(this, value, index, e[dimension]()))
			})
		}
	})

	//
	// these functions are easier to add all at once
	;[ 'after', 'prepend', 'before', 'append' ].forEach(function(name, operator) {
		// check for scripts
		var script_check = function(node){
			if(node.nodeName != null
				&& node.nodeName.toUpperCase() === 'SCRIPT'
				&& (!node.type || node.type === 'text/javascript')
				&& !node.src) //if there is a src, don't eval contents
			window['eval'].call(window, node.innerHTML) // if you have a better way, let me know
		},
		// insert a node
		insert = function(target, node) {
			var parent = operator%2 ? target : target.parentNode
			parent? parent.insertBefore(node,
				!operator ? target.nextSibling :     // after
				operator == 1 ? parent.firstChild :  // prepend
				operator == 2 ? target :             // before
				null
			) : $(node).remove()             // append

		}
		// build the functions into the prototype
		$.fn[name] = function(){
			// arguments can be nodes, arrays of nodes, collections, and html strings
			var nodes = $.map(arguments, function(n){ return is_object(n) ? n : _collection_from_fragment(n) })
			var size = this.length, clone = size > 1, reverse = operator < 2, node, nodelen=nodes.length, i, j
			// insert the nodes
			return nodelen<1 ? this //nothing to do; just return this
				: this.each(function(index, target) {
					for(i=0; i<nodelen; i++) {
						//loop backwards for after and prepend
						node = nodes[reverse ? nodelen-i-1 : i]
						//check this node and all it's kids for "script" tags
						script_check(node)
						for(j in node.childNodes) script_check(node.childNodes[j])
						//insert the node into the dom
						insert(target, clone && index<size-1 ? node.cloneNode(true) : node)
					}
				}
			)
		}
	})

	//
	// extend our collections to use the $.fn functions
	maklik.C.prototype = $.fn;


	/*************************************************************************************************/
	//
	// the "do nothing" function (helps prevent closures from empty anonymous functions)
	$.noop = noop

	//
	// ajax function
	//
	$.ajax = (ajax = function(settings) {
		//prepare settings object
		var o = extend({type:'GET',url: '',params: '',callback: null,async:true,json:false},settings),
			type = o.type.toUpperCase(), params = o.params, headers = o.headers
		//urlencode params if object was passed
		if(is_object(params)) params = $.urlencode(params);
		//prepare xhr
		var xhr = o.xhr || new window.XMLHttpRequest()
		xhr.onreadystatechange = function() {
			if(xhr.readyState==4) {
				//don't do anything if there is no callback
				if(!is_function(o.callback)) return;
				//get the response text or object
				var res = xhr.responseText, status=xhr.status;
				if(o.json) {
					//try to parse json
					try { res = JSON.parse(res); }
					//return an error object if we failed
					catch(err) { res = null, status=-1 }
				}
				//do the callback
				o.callback(res, status, xhr, settings);
			}
		}
		//
		if(type!='GET') {
			xhr.open(type, o.url, o.async);
			xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			if(headers) for(i in headers) xhr.setRequestHeader(i,headers[i])
			xhr.send(params);
		} else {
			xhr.open(type, o.url+(params!=='' ? '?'+params : ''), o.async);
			if(headers) for(i in headers) xhr.setRequestHeader(i,headers[i])
			xhr.send(null);
		}
	})
	//
	// quick ajax functions
	$.get = function(u,p,c) {
		ajax( is_function(p)
			? {url:u, callback: p||c}
			: {url:u, params:p, callback:c}
		)
	}
	$.post = function(u,p,c) {
		var o = { type: 'POST', url: u }
		ajax( extend(is_function(p)
			? { callback: p||c }
			: { params:p, callback: c }
		,o))
	}
	//
	// json-ajax functions
	$.jaax = (jaax = function(settings) { ajax(extend(settings,{json:true})) } )
	$.jget = function(u,p,c) {
		jaax( is_function(p)
			? {url:u, callback: p||c}
			: {url:u, params:p, callback:c}
		)
	}
	$.jpost = function(u,p,c) {
		var o = { type: 'POST', url: u }
		jaax( extend(is_function(p)
			? { callback: p||c }
			: { params:p, callback: c }
		,o))
	}


	//
	// create a blog based on string or object
	//
	$.blob = function(data, ops) {
		var o, b
		// ops can be a string (for "type", or an object of arguments)
		if(!is_object(ops)) ops = {type: ops}
		try {
			// most browsers
			o = new Blob( [data], extend({type: 'text/javascript'},ops));
		} catch(e){
			// try the blob builder
			window.BlobBuilder = window.BlobBuilder
				|| window.WebKitBlobBuilder
				|| window.MozBlobBuilder
				|| window.MSBlobBuilder
			if(e.name=='TypeError' && window.BlobBuilder) {
				b = new BlobBuilder()
				b.append([data.buffer])
				o = b.getBlob(type)
			} else if(e.name=="InvalidStateError") {
				o = new Blob( [data.buffer], {type : type});
			} else return null // blob'ing not supported
		}
		return o
	}


	//
	// clone any object/collection
	//
	$.clone = function(items, deep) {
		var obj = $()
		deep = (deep===false ? false : true) // default is true; must set to false explicitly
		// items can either be an array of elements, or anything which can be passed into $()
		if(is_array(items)) items.forEach(function(o){ obj.add($.clone(o, deep)) }) // array of elements
		else if(is_object(items) && is_jsobject(items)) return extend({},items)     // javascript object/json
		else $(items).each(function(i,d){ obj.add(d.cloneNode(deep)) })             // anything else for $()
		return obj
	}


	//
	// perform some operation on every item in a list or collection
	//
	$.each = function(list, callback) {
		var i,l
		if(is(list.length,Number)) {
			//loop like an array
			for(i=0,l=list.length; i<l; i++)  //yes, it *is* much faster than for-in
			if(callback.call(list[i], i, list[i])===false) return list
		} else {
			//loop as an object
			for(i in list)
			if(callback.call(list[i], i, list[i])===false) return list
		}
		return list
	}


	//
	// copy all non-undefined properties from object(s) to target
	//
	$.extend = (extend = function(target){
		//loop through function arguments...
		slice.call(arguments, 1).forEach(function(source) {
			//foreach argument, add every property to target object
			for(var key in source) if(source[key] !== undefined)
			target[key] = source[key]
		})
		return target
	})


	//
	// page history manipulations
	//
	$.history = function(url,title,state) {
		//push the state
		is_number(url)
			? history.go(url) //number passed means go forward/back by specified amount
			: history.pushState(extend({url:url,title:title},state),!title ? url : title,url)
		return history.state
	}


	//
	// translate all items in list to new array based on success of callback
	//
	$.map = function(list, callback) {
		var i, l=list.length, v, arr=[]
		if(is_number(l)) // assume array (this is significantly faster than "for in"...)
			for(i=0; i<l; i++) if((v=callback(list[i], i))!=null) arr.push(v)
		else             // assume object
			for(i in list) if((v=callback(list[i], i))!=null) arr.push(v)
		// return
		return arr.length > 0 ? [].concat.apply([], arr) : arr
	}


	//
	// current UTC timestamp in seconds from unix epoch
	//
	$.now = function(milliseconds) {
		// default is seconds, use $.now(true) for milliseconds
		return !milliseconds
			? ~~(+new Date / 1000)
			: +new Date
	}


	//
	// html5 storage
	//
	var html5store = function(name,value,sess) {
		var data, dstore = !sess ? window.localStorage : window.sessionStorage
		//get object
		if(value===undefined) {
			//try to parse json
			data = dstore.getItem(name)
			try { return JSON.parse(data); }
			catch(err){ return data } // assume it's a string
		}
		// remove object
		else if(value==null) return dstore.removeItem(name)
		// set object (try/catch to prevent errors with private browsing)
		try { return dstore.setItem(name,JSON.stringify(value)) }
		catch(e) { return value }
	}
	//
	// html5 permanent storage (localStorage)
	$.store = function(name,value) { return html5store(name,value,false) }
	// session storage (sessionStorage)
	$.sess = function(name,value) { return html5store(name,value,true) }


	//
	// urlencode string or object
	//
	$.urlencode = function(item) { // can have multiple arguments, but must have at least one
		// get ready
		var i, v=item, a=arguments, l=a.length, s = []
		// if there are no arguments, return an empty string
		if(l<=0) return ''
		// if there is only one argument, and it's a string, just encode that string (no parameters)
		if(l==1 && is_string(v)) return _urlencode_str(v)
		// there is either an object, collection, dom object, or multiple arguments, make parameter string:
		for(i=0; i<l; i++) v=a[i],
			(v= !v ? '' : is_maklik(v) || (is_object(v) && v.nodeType && v.nodeType==1) // maklik or dom obj
				? _urlencode_dom(v)
				: is_object(v)               // regular javascript object
					? _urlencode_object(v)
					: _urlencode_str(i)+'='+_urlencode_str(v)  // just a string...
			)!='' ? s.push(v) : ''
		// that's it!
		return s.length>0 ? s.join('&') : ''
	}


	//
	// urldecode string or dom node/collection into js object
	//
	$.urldecode = function(str) { // can have multiple arguments
		var s = {}, args = arguments, len = args.length
		// if only one argument is passed, and it's a string without "=", just decode it
		if(len==1 && is_string(str) && str.indexOf('=')<0) return _urldecode_str(str)
		// extend object with result of each argument (leaves empty object {} for no arguments,
		// and does good job of blending multiple arguments into single object)
		slice.call(args).forEach(function(v){
			// if it's a maklik collection or DOM node, get the values from urlencode first
 			if(is_maklik(v) || (is_object(v) && !is_jsobject(v))) v = $.urlencode($(v))
 			// now decode the string
 			v = _urldecode_process(v)
			if(!is_string(v)) extend(s,v)     // extend object with result
			else s[Object.keys(s).length] = v // for strings, add with numeric key index
		})
		return s
	}


	//
	// basic web worker function
	//
	$.work = function(url, msg) {
		// create the web worker (url may be $.blob() object or string url of js file)
		var w = new Worker(is_object(url) ? window.URL.createObjectURL(url) : url), o = $(w),
			i, args = arguments, l = args.length
		// other functions
		w.kill    = w.terminate                                 // terminate the worker
		w.send    = w.postMessage                               // send message to worker
		w.on      = function(){ o.on.apply(o,arguments) }       // event handler
		w.trigger = function(){ o.trigger.apply(o,arguments) }  // trigger event
		// what to do when web worker calls "self.postMessage()"
		if(msg) {
			if(is_function(msg)) o.on('message', msg) // function = onmessage listener
			else  w.send(msg)                         // anything else = first message to send to worker
		}
		// execute any addtional arguments as messages to worker thread
		for(i=2; i<l; i++) w.send(args[i])
		// return the worker object
		return w;
	}


	//
	// return the object we just built (assigns it to "Maklik")
	return $
})();

//
// register '$' to Maklik if it has not yet been defined
//
window.Maklik = Maklik;
'$' in window || (window.$=Maklik);



// WEBPACK FOOTER //
// ./src/maklik.js